import React, { memo } from 'react';
import { Popper } from '@mui/material';
import { makeStyles } from '@mui/styles';

const useStyles = makeStyles(() => ({
  popper: {
    minWidth: 'fit-content',
  },
}));

const CustomPopper = ({ ...props }) => {
  const classes = useStyles();
  return (
    <Popper
      {...props}
      style={{
        popper: classes.popper,
      }}
    />
  );
};

export default memo(CustomPopper);
